// Components/MalwareStepDetail.js

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const MalwareStepDetail = () => {
    const [step, setStep] = useState(null);
    const { stepId } = useParams();

    useEffect(() => {
        const fetchStepDetail = async () => {
            try {
                const response = await axios.get(`http://localhost:3000/api/v1/malware_steps/${stepId}`);
                setStep(response.data);
            } catch (error) {
                console.error("Error fetching malware step detail:", error);
            }
        };

        fetchStepDetail();
    }, [stepId]);

    return (
        <div>
            {step && (
                <>
                    <h2>Step Detail</h2>
                    <p>{step.description.body}</p>
                </>
            )}
        </div>
    );
}

export default MalwareStepDetail;
